import * as signalR from '@microsoft/signalr';
import { config } from '../config';

class SignalRService {
  private static instance: SignalRService;
  private _connection: signalR.HubConnection | null = null;
  private _roomId: string | null = null;

  private constructor() {}

  static getInstance(): SignalRService {
    if (!SignalRService.instance) {
      SignalRService.instance = new SignalRService();
    }
    return SignalRService.instance;
  }

  get connection(): signalR.HubConnection | null {
    return this._connection;
  }

  get roomId(): string | null {
    return this._roomId;
  }

  setRoomId(roomId: string | null) {
    this._roomId = roomId;
  }

  get isConnected(): boolean {
    return this._connection?.state === signalR.HubConnectionState.Connected;
  }

  createConnection(accessToken: string): signalR.HubConnection {
    if (this._connection) {
      return this._connection;
    }

    this._connection = new signalR.HubConnectionBuilder()
      .withUrl(config.hubUrl, {
        accessTokenFactory: () => accessToken,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    return this._connection;
  }

  async disconnect() {
    if (this._connection) {
      try {
        await this._connection.stop();
      } catch {
        // Ignore errors during disconnect
      }
      this._connection = null;
    }
    this._roomId = null;
  }
}

export const signalRService = SignalRService.getInstance();
